'use client';

import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { client } from '@/api/client';
import { handleError } from '@/utils/errorHandler';
export const addComment = async (planId: string | number, content: string): Promise<boolean | undefined> => {
  try {
    const res = await client.post(`/plans/${planId}/comments`, {
      content
    });
    return res ? true : false;
  } catch (error) {
    handleError(error);
  }
};
export function useAddComment(): UseMutationResult<boolean | undefined, Error, {
  content: string;
  planId: string;
}, unknown> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      content,
      planId
    }: {
      content: string;
      planId: string;
    }) => addComment(planId, content),
    mutationKey: ['addComment'],
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries({
        queryKey: ['pdp-documents']
      });
    }
  });
}